export function EmailSignature({ name, title, email, phone }: { name?: string; title?: string; email?: string; phone?: string }) {
  const person = (name || '').trim();
  const role = (title || '').trim();
  const mail = (email || '').trim();
  const mobile = (phone || '').trim();
  return (
    <table className="mt-6 w-full max-w-xl border-collapse bg-[#1a1a1a] text-[#f5f5f5]">
      <tbody>
        <tr>
          <td className="px-4 py-4 align-top">
            <img src="https://www.maxiron.com/maxiron-logo.png" alt="Maxiron" width={160} />
            <img className="mt-3" src="https://www.maxiron.com/ibm-gold-partner.webp" alt="IBM Gold Partner" width={90} />
          </td>
          <td className="w-[3px] bg-[#7C3AED]" />
          <td className="px-4 py-4 align-top">
            {person ? <div className="text-lg font-bold">{person}</div> : null}
            {role ? <div className="pt-0.5 text-sm text-[#c4c4c4]">{role}</div> : null}
            <table className="mt-2 border-collapse text-sm">
              <tbody>
                {mail ? (
                  <tr>
                    <td className="pr-3 text-[11px] font-bold tracking-wide text-[#7C3AED]">EMAIL</td>
                    <td>{mail}</td>
                  </tr>
                ) : null}
                {mobile ? (
                  <tr>
                    <td className="pr-3 text-[11px] font-bold tracking-wide text-[#7C3AED]">MOBILE</td>
                    <td>{mobile}</td>
                  </tr>
                ) : null}
                <tr>
                  <td className="pr-3 text-[11px] font-bold tracking-wide text-[#7C3AED]">WEB</td>
                  <td>maxiron.com</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td colSpan={3} className="bg-[#111111] px-4 py-2 text-[11px] text-[#d0d0d0]">
            IBM Partner Plus 8294 · ISO/IEC 27001:2022 27274 · ISO 9001:2015 27274 · UK G-Cloud 14 721548
          </td>
        </tr>
        <tr>
          <td colSpan={3} className="bg-[#111111] px-4 pb-2 text-[11px] text-[#d0d0d0]">
            Maxiron Ltd (England & Wales) · 3rd Floor, 86-90 Paul Street, London EC2A 4NE
          </td>
        </tr>
      </tbody>
    </table>
  );
}
